import React, { forwardRef, useContext } from 'react';
import { theme } from '@contrast-security-inc/design-system-foundations';
import { Button } from '../Button';
import { ToggleButtonContext } from '../ToggleButtonProvider';
import { css, cx } from '@emotion/css';
const activeStyles = css `
  background-color: ${theme.color.neutral70};
  color: ${theme.color.white};

  &:focus:enabled {
    color: ${theme.color.white};
  }

  svg {
    fill: ${theme.color.white};
  }

  &:focus:enabled svg {
    fill: ${theme.color.white};
  }

  &:hover:enabled {
    background-color: ${theme.color.neutral80};
  }
`;
const inactiveStyles = css `
  &:hover:enabled {
    background-color: ${theme.color.neutral50};
    color: ${theme.color.neutral100};
  }

  &:hover:enabled svg {
    fill: ${theme.color.neutral100};
  }
`;
function ToggleButtonInner(props, ref) {
    const { children, value, className: userClassName, testId, ...rest } = props;
    const context = useContext(ToggleButtonContext);
    if (!context) {
        throw new Error('ToggleButton must be rendered as a child of ToggleButtonGroup');
    }
    const { value: contextValue, onChange } = context;
    const isSelected = contextValue === value;
    const className = cx(isSelected ? activeStyles : inactiveStyles, userClassName, 'ds-toggle-button');
    return (React.createElement(Button, { ref: ref, ...rest, variant: "secondary", onClick: () => onChange(value), className: className, "aria-pressed": isSelected, "data-testid": testId }, children));
}
ToggleButtonInner.displayName = 'ToggleButton';
export const ToggleButton = forwardRef(ToggleButtonInner);
